import "./Contact.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import DealerApplicationGateway from "./sections/DealerApplicationGateway";
import VisitOurStudio from "./sections/VisitOurStudio";
import OurExpertTeam from "./sections/OurExpertTeam";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <ClinicHeader />
      <DealerApplicationGateway />
      <VisitOurStudio />
      <OurExpertTeam />
      <Footer />
    </div>;
}